export const Imagegallery = () => {
    return (
        <section className="roservice">
            <div className="container">
                <h2>Water Purifier Services &amp;RO Repair &amp; RO Installation Repair Provider</h2>
                <div className="row">
                    <div className="col-md-4">
                        <div className="service1">
                            <img src="img/imagegallery/rorepair.jpg" className="img-fluid" alt="ro service in Patna" />
                            <div className="backser">
                                <h3>Ro Repair</h3>
                                <p>Regular maintenance of your RO system is essential for optimal performance and long-lasting durability. Our skilled technicians in Patna provide thorough RO servicing, including filter replacement, membrane cleaning, and inspection for leaks or other issues. We also offer customized maintenance plans to ensure your RO system consistently delivers safe, pure drinking water.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="service1">
                            <img src="img/imagegallery/roinstall.jpg" className="img-fluid" alt="ro repair in Patna" />
                            <div className="backser">
                                <h3>Ro Installation</h3>
                                <p>Installing a Reverse Osmosis (RO) system is vital for ensuring clean and safe drinking water in your home or office. At RO Care Service, we provide professional and reliable RO installation in Patna, carried out by skilled technicians who ensure quick, accurate, and efficient setup. We also help you choose the right RO system based on your water quality and usage needs, ensuring the best purification performance.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="service1">
                            <img src="img/imagegallery/roservice21.png" className="img-fluid" alt="aquaguard ro service in Patna" />
                            <div className="backser">
                                <h3>Water Quality Check</h3>
                                <p>Reliable and comprehensive water quality testing services available across Patna. Our team of skilled professionals conducts in-depth assessments to check for impurities, contaminants, and overall water safety. We ensure that your drinking water meets all essential health and quality standards, giving you confidence and peace of mind about the water you use every day.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}